<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Subscribe'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="'right-side-scroll-enabled'">

    @if (isCheckingSubscription()) {
      <!-- Confirming the account isn't already subscribed before showing any payment form. -->
      <tidy-row>
        <ion-skeleton-text animated style="width: 45%; height: 22px;" />
      </tidy-row>
      <tidy-card>
        <ion-skeleton-text animated style="width: 100%; height: 22px;" />
        <ion-skeleton-text animated style="width: 80%; height: 22px;" />
        <ion-skeleton-text animated style="width: 60%; height: 22px;" />
      </tidy-card>
    } @else {

    <!-- Your Subscription + Optional Add-Ons -->
    <subscription-plan-card
      [unitCount]="unitCount()"
      [(cleaningMaintenanceOn)]="cleaningMaintenanceOn"
      [cleaningMaintenanceLocked]="dueTodayCharged()"
      (hardwareAddOnTapped)="gateHardwareAddOn()" />

    <!-- Payment Method Section -->
    <tidy-row class="extra-top-padding">
      <tidy-text [title]="hasExistingCard() ? 'Payment Method' : 'Add Payment Method'" />
    </tidy-row>

    <tidy-card>
      @if (cardAdded()) {
        <tidy-alert>
          <tidy-row class="no-padding">
            <tidy-image [src]="'assets/img/checkmark-circle-green.svg'" class="header-size" />
            <tidy-text [body]="cardBrand() + (' ending in ' | translate) + cardLast4()" />
          </tidy-row>
        </tidy-alert>
      }

      @if (!cardAdded() && hasExistingCard() && !isEditingCard()) {
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-text [body]="('Use card ending in ' | translate) + existingCardLast4()" /><span>&nbsp;</span>
          <tidy-text [actionBody]="'Edit'" (action)="onEditCard()" class="white-link" />
        </tidy-row>
      }

      @if (!cardAdded() && (!hasExistingCard() || isEditingCard())) {
        @if (!stripeReady()) {
          <div class="form-row">
            <ion-skeleton-text animated style="width: 100%; height: 22px; margin: 0;" />
          </div>
        }
        <div class="form-row" [class.stripe-loading]="!stripeReady()">
          <form>
            <div id="card-info" #cardInfo></div>
          </form>
        </div>
      }

      <!-- Outside the card form on purpose: a declined charge on a saved card has no form to
           attach to, and this used to be the only place the failure was shown. -->
      @if (errorMessage) {
        <tidy-error-message [text]="errorMessage" />
      }

      <tidy-row [align]="'center'">
        <tidy-text [body]="('<b>Due today: $' | translate) + dueTodayDollars() + ('</b> — ' | translate) + (cleaningMaintenanceOn() ? 'this covers your first month of Cleaning & Maintenance.' : 'this stays in your account as credit toward your 3.9% booking fees.') + ' ' + ('You will not be charged 3.9% for any reservations scheduled for the next 7 days.' | translate)" />
      </tidy-row>

      <div class="ea-guarantee-badges">
        <span class="ea-shield-badge">
          <tidy-image [src]="'assets/svg/shield-checkmark-outline.svg'" class="ea-shield-icon" />
          More Profit Guaranteed
        </span>
        <span class="ea-shield-badge">
          <span class="ea-shield-badge-check">✓</span>
          Cancel Anytime · No Contract
        </span>
      </div>
    </tidy-card>

    <!-- Subscribe Now button -->
    <tidy-button
      [text]="'Subscribe Now'"
      [action]="goLive.bind(this)"
      class="primary ea-hero-btn extra-top-padding extra-bottom-padding" />

    <tidy-row [align]="'center'" class="extra-bottom-padding">
      <tidy-text [body]="'<b>Trusted 13+ years by 100,000+ homeowners & property managers</b>'" />
    </tidy-row>

    <!-- Testimonials -->
    <tidy-alert class="black-background">
      <div class="ea-testimonial">
        <p class="ea-testimonial-text">"TIDY handles all the day-to-day operations. I focus on providing strategic value to my clients."</p>
        <div class="ea-testimonial-author">
          <div class="ea-author-info">
            <span class="ea-author-name">James R.</span>
            <span class="ea-author-detail">Property Manager · 45 units · Denver, CO</span>
          </div>
          <span class="ea-author-stars">★★★★★</span>
        </div>
      </div>
    </tidy-alert>

    <tidy-alert class="black-background">
      <div class="ea-testimonial">
        <p class="ea-testimonial-text">"I never wanted to use a property manager because of the cost. TIDY saves me all the work at a fraction of the price."</p>
        <div class="ea-testimonial-author">
          <div class="ea-author-info">
            <span class="ea-author-name">Sarah M.</span>
            <span class="ea-author-detail">Airbnb Host · 8 properties · Austin, TX</span>
          </div>
          <span class="ea-author-stars">★★★★★</span>
        </div>
      </div>
    </tidy-alert>

    }

  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
